import React, { useState } from "react";
import styles from "./NewCompanyModel.module.css";
import axios from "axios";
import config from "../../../../../service/config";
import companyStore from "../../../CompanyStore";
import { useAllProduct } from "../../../../api-context/commonApiContext";

export default function NewCompanyModel({
  className = "",
  isVisible,
  onclose,
  setShowModel,
  modalRef,
  compName,
  setCompName,
  errorMsg,
  setErrorMsg,
}) {
  const { authTokens, loader, setLoader } = useAllProduct();

  const HandleData = () => {
    if (compName.trim() === "") {
      setErrorMsg("Company Name is Required");
      return;
    }
    if (compName.trim().length < 5) {
      setErrorMsg("Company Name must be at least 5 characters long");
      return;
    }

    const payload = {
      escrow_id: companyStore.escrowId,
      created_by: companyStore?.AdminEmail,
      company_name: compName,
    };
    setLoader(true);
    axios
      .post(`${config.node_api_endpoint}/v2/company/create`, payload, {
        headers: {
          aws_cognito_id_token: authTokens.idToken,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setLoader(false);
        console.log("Company Added");
        setCompName("");
        onclose();
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.data?.message || err.message) {
          setErrorMsg(`${err.response?.data?.message || err.message}`);
        } else {
          setCompName("");
          onclose();
        }
      });
  };
  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.newModelcontainer}>
      <div ref={modalRef} className={[styles.addCompany, className].join(" ")}>
        {/* <div className={styles.newCompany}>Create New Company</div> */}
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span style={{ fontWeight: "500" }}>Create New Company</span>
          <img
            className={styles.xCircleIcon}
            alt=""
            src="/xcircle.svg"
            onClick={() => {
              // onClose();
              setShowModel(false);
              setCompName("");
              setErrorMsg("");
            }}
          />
        </div>

        <div className={styles.mobileMenuParent}>
          <div className={`${styles.mobileMenu} mb-1`}>
            <input
              placeholder="Company Name"
              value={compName}
              className={styles.field}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length > 100) {
                  setErrorMsg("Comapny Name cannot exceed 100 characters");
                } else {
                  setErrorMsg("");
                }
                setCompName(value);
              }}
            />

            <img className={styles.trailingIcon2} alt="" src="/trailingicon-21.svg" />
          </div>
          {errorMsg && <div className={`${styles.errorMsg}`}>{errorMsg}</div>}
          <div className="w-100 d-flex justify-content-between m-1">
            <div
              className={`${styles.loadsButtons} w-50 p-2`}
              onClick={() => {
                setCompName("");
                setErrorMsg("");
                onclose();
              }}
            >
              <div style={{ fontWeight: "700", fontSize: "16px" }}>Cancel</div>
            </div>
            <div
              className={`${styles.loadsButtons1} w-50 mx-2`}
              onClick={() => {
                HandleData();
              }}
            >
              <img className={styles.boxArrowInDownIcon} alt="" src="/boxarrowindown3.svg" />
              <b className={styles.loads}>Create</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
